// @flow
import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import ReputationStar from 'components/molecules/ReputationStar'

export const Container = styled.ul`
  margin-bottom: 16px;

  li {
    display: inline;
  }
`

export const StarsContainer = styled.li`
  font-size: 20px;
`

export const Rating = styled.li`
  font-size: 18px;
  margin-left: 8px;
`

export const ReviewCount = styled.li`
  font-size: 12px;
  margin-left: 12px;
  color: ${Colors.black};
`

export const ReviewCountHeader = styled.span`
  font-size: 14px;
  font-weight: bold;
  margin-right: 3px;
`

type PropTypes = {
  score: number,
  count: number,
  linkUrl: number,
}

export default (props: PropTypes) => (
  <ul
    className="mod-review__head"
    itemProp="aggregateRating"
    itemScope
    itemType="http://schema.org/AggregateRating"
  >
    <li className="mod-review__head-star">
      <ReputationStar {...props} />
    </li>
    <li className="mod-review__head-rating" itemProp="ratingValue">
      {(parseInt(props.score * 100, 10) || 0) / 100}
    </li>
    <li itemProp="reviewCount">
      <a href={props.linkUrl} className="space-head__list-number">
        {props.count}
        {i18n.t('page.shared.review.readAllReviews')}
      </a>
    </li>
  </ul>
)



// WEBPACK FOOTER //
// ./src/components/organisms/ReputationListHeader/index.jsx